import React from 'react'
import { isValidCPF } from '@byma/shared/helpers/validators'
import Router from 'next/router'
import VMasker from 'vanilla-masker'

export default function SearchInput({ currentQuery }) {
    function handleFilter(e) {
        e.preventDefault()
        let key = e.currentTarget.query.value
        let url = new URL(window.location.href)
        let searchParams = url.searchParams
        if (isValidCPF(key)) {
            key = VMasker.toPattern(key, '999.999.999-99')
        }
        searchParams.set('q', key)
        url.search = searchParams.toString()
        Router.push(url.toString())
    }

    return (
        <div className="">
            <div className="flex justify-between items-center rounded shadow px-2 py-1 hover:shadow-md whitespace-nowrap space-x-1">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-700" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                </svg>
                <form onSubmit={handleFilter}>
                    <input className="outline-none text-sm w-56" placeholder="Buscar..." defaultValue={currentQuery} name="query"/>
                </form>
            </div>
        </div>
    )

}
